<template>
  <v-card>
    <div class="pt-2">
      <v-card flat>
        <v-row class="d-flex justify-space-between padding-bottom">
          <div>
            <v-btn
                depressed
                color="primary"
                v-on:click="back()"
            >
              返回
            </v-btn>
          </div>
          <div>
            <v-btn
                depressed
                color="primary"
                class="margin-right"
                @click="clickAudit()"
                :disabled="!(infoData.status==2&&_hasButtonPermission('审批'))"
            >
              审批
            </v-btn>
            <v-btn
                depressed
                color="primary"
                @click="clickExport()"
                :disabled="!_hasButtonPermission('导出详情')"
            >
              导出
            </v-btn>
          </div>
        </v-row>
        <!-- <v-card-text>{{ item.content }}</v-card-text> -->
        <v-item-group>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-item>
                  <v-card class="d-flex align-center" height="75">
                    <v-card-text class="mt-5"
                    >
                      <div>综合得分</div>
                      <p class="text-h4 text--primary">
                        {{ infoData.totalScore }}
                      </p></v-card-text
                    >
                  </v-card>
                </v-item>
              </v-col>
              <!--<v-col cols="12" md="2">
                <v-item>
                  <v-card class="d-flex align-center" height="75">
                    <v-card-text class="mt-5"
                      ><div>当前类得分</div>
                      <p class="text-h4 text--primary">
                        {{infoData.categoryScore}}/{{infoData.categoryTotalScore}}
                      </p></v-card-text
                    >
                  </v-card>
                </v-item>
              </v-col>-->
              <v-col cols="12" md="2">
                <v-item>
                  <v-card class="d-flex align-center" height="75">
                    <v-card-text class="mt-5"
                    >
                      <div>全部待销项</div>
                      <p class="text-h4 text--primary">
                        {{ infoData.preWriteOffAmount }}/{{ infoData.totalQuestionAmount }}
                      </p></v-card-text
                    >
                  </v-card>
                </v-item>
              </v-col>
              <v-col cols="12" md="2">
                <v-item>
                  <v-card class="d-flex align-center" height="75">
                    <v-card-text class="mt-5"
                    >
                      <div>当前类待销项</div>
                      <p class="text-h4 text--primary">
                        {{ infoData.categoryPreWriteOffAmount }}/{{ infoData.categoryQuestionAmount }}
                      </p></v-card-text
                    >
                  </v-card>
                </v-item>
              </v-col>
              <v-col cols="12" md="2">
                <v-item>
                  <v-card class="d-flex align-center" height="75">
                    <v-card-text class="mt-5"
                    >
                      <div>全部扣分项</div>
                      <p class="text-h4 text--primary">
                        {{ infoData.totalWillPointAmount }}/{{ infoData.totalPointAmount }}
                      </p></v-card-text
                    >
                  </v-card>
                </v-item>
              </v-col>
              <v-col cols="12" md="2">
                <v-item>
                  <v-card class="d-flex align-center" height="75">
                    <v-card-text class="mt-5"
                    >
                      <div>当前类待销扣分项</div>
                      <p class="text-h4 text--primary">
                        {{ infoData.categoryWillPointAmount }}/{{ infoData.categoryPointAmount }}
                      </p></v-card-text
                    >
                  </v-card>
                </v-item>
              </v-col>
            </v-row>
          </v-container>
        </v-item-group>
        <v-row>
          <v-tabs v-model="tab" background-color="primary" dark>
            <v-tab
                v-for="item in items"
                :key="item.tab"
                :href="'#tab-' + item.tab"
                @change="tabChange(item.id)"
            >
              {{ item.tab }}
            </v-tab>
          </v-tabs>
          <v-simple-table
              fixed-header
              height="750px"
          >
            <!--基础-->
            <template v-slot:default v-if="categoryId==1">
              <thead>
              <tr>
                <th class="text-left">
                  考核项目
                </th>
                <th class="text-left">
                  考核内容
                </th>
                <th class="text-left">
                  考核方法
                </th>
                <th class="text-left">
                  扣分
                </th>
                <th class="text-left">
                  分值
                </th>
                <th class="text-left">
                  隐患等级
                </th>
                <th class="text-left">
                  问题
                </th>
                <th class="text-left">
                  备注
                </th>
                <th class="text-left">
                  销项状态
                </th>
                <th class="text-left">
                  销项计划日期
                </th>
                <th class="text-left">
                  销项日期
                </th>
                <th class="text-left">
                  销项说明
                </th>
                <th class="text-center">
                  操作
                </th>
              </tr>
              </thead>
              <tbody>
              <template v-for="(item,index) in infoData.dataList">
                <tr v-for="(m,i) in item.pointList" :key="m.id">
                  <td v-if="i==0" :rowspan="item.pointList.length">{{ item.name }}</td>
                  <td>{{ m.assessContent }}</td>
                  <td>{{ m.assessMethod }}</td>
                  <td>{{ m.deductPoints }}</td>
                  <td>{{ m.score }}</td>
                  <td v-if="i==0" :rowspan="item.pointList.length">{{ item.question.dangerLevel }}</td>
                  <td v-if="i==0" :rowspan="item.pointList.length">{{ item.question.question }}</td>
                  <td v-if="i==0" :rowspan="item.pointList.length">{{ item.question.remarks }}</td>
                  <td v-if="i==0" :rowspan="item.pointList.length">
                    <v-chip
                        color="orange"
                        dark
                    >
                      {{ _jungleWriteOffStatus(item.question.writeOffStatus) }}
                    </v-chip>
                  </td>
                  <td v-if="i==0" :rowspan="item.pointList.length">{{ item.question.writeOffPlanTime }}</td>
                  <td v-if="i==0" :rowspan="item.pointList.length">{{ item.question.writeOffTime }}</td>
                  <td v-if="i==0" :rowspan="item.pointList.length">{{ item.question.writeOffExplain }}</td>
                  <td v-if="i==0" :rowspan="item.pointList.length">
                    <v-btn text color="primary" block small @click="viewPictures(item.question)">查看图片</v-btn>
                    <v-btn text color="primary" block small
                           :disabled="!(item.question.writeOffStatus==3&&_hasButtonPermission('销项计划日期'))"
                           @click="clickWriteOffPlanTime(item.question)">销项计划日期
                    </v-btn>
                    <v-btn text color="primary" block small
                           :disabled="!(item.question.writeOffStatus==3&&_hasButtonPermission('销项'))"
                           @click="clickWrite(item.question)">销项
                    </v-btn>
                  </td>
                </tr>
              </template>
              </tbody>
            </template>
            <!--建筑-->
            <template v-slot:default v-else-if="categoryId==2">
              <thead>
              <tr>
                <th class="text-left">
                  考核项目
                </th>
                <th class="text-left">
                  设备分类
                </th>
                <th class="text-left">
                  检查标准
                </th>
                <th class="text-left">
                  检查方法
                </th>
                <th class="text-left">
                  扣分
                </th>
                <th class="text-left">
                  分值
                </th>
                <th class="text-left">
                  隐患等级
                </th>
                <th class="text-left">
                  问题
                </th>
                <th class="text-left">
                  备注
                </th>
                <th class="text-left">
                  销项状态
                </th>
                <th class="text-left">
                  销项计划日期
                </th>
                <th class="text-left">
                  销项日期
                </th>
                <th class="text-left">
                  销项说明
                </th>
                <th class="text-center">
                  操作
                </th>
              </tr>
              </thead>
              <tbody>
              <template v-for="(item,index) in infoData.dataList">
                <template v-for="(it,ind) in item.children">
                  <tr v-for="(m,i) in it.pointList" :key="m.id">
                    <td v-if="ind==0&&i==0" :rowspan="_calcRow32(item.children)">{{ item.name }}</td>
                    <td v-if="i==0" :rowspan="it.pointList.length">{{ it.name }}</td>
                    <td>{{ m.assessContent }}</td>
                    <td>{{ m.assessMethod }}</td>
                    <td>{{ m.deductPoints }}</td>
                    <td>{{ m.score }}</td>
                    <td v-if="i==0" :rowspan="it.pointList.length">{{ it.question.dangerLevel }}</td>
                    <td v-if="i==0" :rowspan="it.pointList.length">{{ it.question.question }}</td>
                    <td v-if="i==0" :rowspan="it.pointList.length">{{ it.question.remarks }}</td>
                    <td v-if="i==0" :rowspan="it.pointList.length">
                      <v-chip
                          color="orange"
                          dark
                      >
                        {{ _jungleWriteOffStatus(it.question.writeOffStatus) }}
                      </v-chip>
                    </td>
                    <td v-if="i==0" :rowspan="it.pointList.length">{{ it.question.writeOffPlanTime }}</td>
                    <td v-if="i==0" :rowspan="it.pointList.length">{{ it.question.writeOffTime }}</td>
                    <td v-if="i==0" :rowspan="it.pointList.length">{{ it.question.writeOffExplain }}</td>
                    <td v-if="i==0" :rowspan="it.pointList.length">
                      <v-btn text color="primary" block small @click="viewPictures(it.question)">查看图片</v-btn>
                      <v-btn text color="primary" block small
                             :disabled="!(it.question.writeOffStatus==3&&_hasButtonPermission('销项计划日期'))"
                             @click="clickWriteOffPlanTime(it.question)">销项计划日期
                      </v-btn>
                      <v-btn text color="primary" block small
                             :disabled="!(it.question.writeOffStatus==3&&_hasButtonPermission('销项'))"
                             @click="clickWrite(it.question)">销项
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </template>
              </tbody>
            </template>
            <!--其他-->
            <template v-slot:default v-else>
              <thead>
              <tr>
                <th class="text-left">
                  考核项目
                </th>
                <th class="text-left">
                  设备分类
                </th>
                <th class="text-left">
                  设备名称
                </th>
                <th class="text-left">
                  检查标准
                </th>
                <th class="text-left">
                  检查方法
                </th>
                <th class="text-left">
                  扣分
                </th>
                <th class="text-left">
                  分值
                </th>
                <th class="text-left">
                  隐患等级
                </th>
                <th class="text-left">
                  问题
                </th>
                <th class="text-left">
                  备注
                </th>
                <th class="text-left">
                  销项状态
                </th>
                <th class="text-left">
                  销项计划日期
                </th>
                <th class="text-left">
                  销项日期
                </th>
                <th class="text-left">
                  销项说明
                </th>
                <th class="text-center">
                  操作
                </th>
              </tr>
              </thead>
              <tbody>
              <template v-for="(item,index) in infoData.dataList">
                <template v-for="(it,ind) in item.children">
                  <template v-for="(itemz,indexz) in it.children">
                    <tr v-for="(m,i) in itemz.pointList" :key="m.id">
                      <td v-if="ind==0&&indexz==0&i==0" :rowspan="_calcRow31(item.children)">{{ item.name }}</td>
                      <td v-if="indexz==0&&i==0" :rowspan="_calcRow32(it.children)">{{ it.name }}</td>
                      <td v-if="i==0" :rowspan="itemz.pointList.length">{{ itemz.name }}</td>
                      <td>{{ m.assessContent }}</td>
                      <td>{{ m.assessMethod }}</td>
                      <td>{{ m.deductPoints }}</td>
                      <td>{{ m.score }}</td>
                      <td v-if="indexz==0&&i==0" :rowspan="_calcRow32(it.children)">{{ it.question.dangerLevel }}</td>
                      <td v-if="indexz==0&&i==0" :rowspan="_calcRow32(it.children)">{{ it.question.question }}</td>
                      <td v-if="indexz==0&&i==0" :rowspan="_calcRow32(it.children)">{{ it.question.remarks }}</td>
                      <td v-if="indexz==0&&i==0" :rowspan="_calcRow32(it.children)">
                        <v-chip
                            color="orange"
                            dark
                        >
                          {{ _jungleWriteOffStatus(it.question.writeOffStatus) }}
                        </v-chip>
                      </td>
                      <td v-if="indexz==0&&i==0" :rowspan="_calcRow32(it.children)">{{ it.question.writeOffPlanTime }}
                      </td>
                      <td v-if="indexz==0&&i==0" :rowspan="_calcRow32(it.children)">{{ it.question.writeOffTime }}</td>
                      <td v-if="indexz==0&&i==0" :rowspan="_calcRow32(it.children)">{{ it.question.writeOffExplain }}
                      </td>
                      <td v-if="indexz==0&&i==0" :rowspan="_calcRow32(it.children)">
                        <v-btn text color="primary" block small @click="viewPictures(it.question)">查看图片</v-btn>
                        <v-btn text color="primary" block small
                               :disabled="!(it.question.writeOffStatus==3&&_hasButtonPermission('销项计划日期'))"
                               @click="clickWriteOffPlanTime(it.question)">销项计划日期
                        </v-btn>
                        <v-btn text color="primary" block small
                               :disabled="!(it.question.writeOffStatus==3&&_hasButtonPermission('销项'))"
                               @click="clickWrite(it.question)">销项
                        </v-btn>
                      </td>
                    </tr>
                  </template>
                </template>
              </template>
              </tbody>
            </template>
          </v-simple-table>
        </v-row>
      </v-card>
    </div>
    <!--查看图片弹窗-->
    <v-dialog
        persistent
        v-model="dialogShow"
        width="700"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          查看
        </v-card-title>
        <v-card-text>
          <template v-if="questionImgs">
            <v-row>
              <p class="text-h5 text--primary">
                问题图片
              </p>
            </v-row>
            <v-row>
              <v-col
                  v-for="(item,index) in questionImgs"
                  :key="index"
                  class="d-flex child-flex"
                  cols="3"
              >
                <img
                    :src="item"
                    aspect-ratio="1"
                    class="grey lighten-2"
                    preview="0"
                    width="139"
                    height="139"
                    style="object-fit: cover"
                >
              </v-col>
            </v-row>
          </template>
          <template v-if="writeOffImgs">
            <v-row>
              <p class="text-h5 text--primary">
                销项图片
              </p>
            </v-row>
            <v-row>
              <v-col
                  v-for="(item,index) in writeOffImgs"
                  :key="index"
                  class="d-flex child-flex"
                  cols="3"
              >
                <img
                    :src="item"
                    aspect-ratio="1"
                    class="grey lighten-2"
                    preview="1"
                    width="139"
                    height="139"
                    style="object-fit: cover"
                >
              </v-col>
            </v-row>
          </template>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="primary"
              text
              @click="closeImgDialog()"
          >
            关闭
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--修改计划销项时间-->
    <v-dialog
        v-model="planTimeDialogShow"
        persistent
        max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">销项计划日期</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                  cols="12"
                  sm="8"
              >
                <date-picker label="计划日期" v-model="planTime"></date-picker>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              @click="quxiaoChangePlanTime()"
          >
            取消
          </v-btn>
          <v-btn
              color="primary"
              text
              :disabled="btnDisabled"
              @click="sureChangePlanTime()"
          >
            修改
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--销项弹窗-->
    <v-dialog
        v-model="writeOffDialogShow"
        persistent
        max-width="700px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">销项</span>
        </v-card-title>
        <v-card-text>
          <v-card flat>
            <v-form v-model="writeOffValid">
              <v-row no-gutters>
                <v-col cols="12" sm="2" style="text-align: left">
                  <label>销项说明：</label>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                      v-model="writeOffExplain"
                      single-line
                      outlined
                      dense
                      required
                      :rules="rules"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row no-gutters style="margin-top: 12px;">
                <v-col cols="12" sm="2" style="text-align: left">
                  <label>销项图片：</label>
                </v-col>
              </v-row>
              <v-row no-gutters style="margin-top: 12px;">
                <v-col cols="12" sm="12" style="text-align: left">
                  <el-upload
                      ref="specUploadPic"
                      :action="uploadUrl"
                      :headers="headers"
                      name="file"
                      :limit="4"
                      :data="uploadData"
                      list-type="picture-card"
                      accept="jpeg, jpg, png"
                      :file-list="uploadPics"
                      :on-remove="handleRemove"
                      :on-success="handleAvatarSuccess"
                      :on-exceed="handleExceed"
                      :before-upload="beforeAvatarUpload"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </v-col>
              </v-row>
            </v-form>
          </v-card>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              @click="closeWriteOff"
          >
            取消
          </v-btn>
          <v-btn
              color="blue darken-1"
              text
              :disabled="btnDisabled"
              @click="sureWriteOff"
          >
            销项
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--审批弹窗-->
    <v-dialog
        v-model="auditDialog"
        width="300"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          请审批
        </v-card-title>
        <v-card-text>
          <div class="padding-bottom padding-top">
            <v-btn
                depressed
                color="primary"
                class="margin-right"
                :disabled="btnDisabled"
                @click="auditApprove()"
            >
              审批通过
            </v-btn>
            <v-btn
                depressed
                color="primary"
                :disabled="btnDisabled"
                @click="auditDismissal()"
            >
              驳回
            </v-btn>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="primary"
              text
              @click="auditDialog = false"
          >
            取消
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import {default as CheckRecordApi} from "@/api/pd/check/checkRecord/CheckRecordApi.js";
import downloadUtil from "@/util/downloadUtil.js";
import Auth from "@/util/auth";

export default {
  props: {
    id: [Number, String],
    buttonPriviledgeList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      tab: null,
      statusList: [
        {id: 1, name: "待提交"},
        {id: 2, name: "待审批"},
        {id: 3, name: "执行中"},
        {id: 4, name: "已过期"},
        {id: 5, name: "已终止"},
      ],
      infoData: {},
      // 上传的headers
      headers: {
        "HC-SMP-Authorization": Auth.getAccessToken()
      },
      items: [
        {tab: "基础管理", id: 1},
        {tab: "建筑装饰", id: 2},
        {tab: "给排水", id: 3},
        {tab: "强电", id: 4},
        {tab: "空调", id: 5},
        {tab: "弱电", id: 6},
        {tab: "电梯", id: 7},
        {tab: "二装管理", id: 8},
        {tab: "消防", id: 9}
      ],
      categoryId: null,
      btnDisabled: false,
      dialogShow: false,
      questionImgs: null,
      writeOffImgs: null,
      planTimeDialogShow: false,
      questionId: null,
      planTime: null,
      writeOffDialogShow: false,
      writeOffValid: false,
      rules: [(v) => !!v || '必填'],
      writeOffExplain: "", // 销项原因
      uploadPics: [],
      uploadUrl: null, // 固定上传图片路径
      auditDialog: false,
      uploadData: {
        path: ''
      }
    };
  },
  mounted() {
    // 默认取1
    this.getDataFromApi(1);
    this.uploadUrl = CheckRecordApi.IMG_UPLOAD_URL;
    this.uploadData.path = '/wgManager/' + this._getTodayDateStr()
  },
  methods: {
    back() {
      this.$emit("back")
    },
    // 删除图片
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    // 上传前校验
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 < 500;
      if (!isLt2M) {
        this.$dialog.error({
          title: '错误',
          text: '上传图片大小不能超过 500KB!'
        })
      }
      return isLt2M;
    },
    // 超出上传限制
    handleExceed() {
      this.$dialog.error({
        title: '错误',
        text: '做多上传4张图片'
      })
    },
    // 上传成功
    handleAvatarSuccess(res, file, fileList) {
      console.log("file", file);
      console.log("fileList", fileList);
      file.url = res.data;
    },
    // 切换分类
    tabChange(id) {
      this.getDataFromApi(id)
    },
    getDataFromApi(categoryId) {
      let me = this
      let checkId = this.id
      CheckRecordApi.detailCheckOrder({
        checkId: checkId,
        categoryId: categoryId
      }).then(resp => {
        CheckRecordApi.handleResponse(resp, me, function (data) {
          me.categoryId = categoryId;
          me.infoData = data;
        })
      })
    },
    // 点击审批
    clickAudit() {
      this.auditDialog = true
    },
    // 审批通过
    auditApprove() {
      let checkId = this.id
      let me = this
      me.btnDisabled = true
      CheckRecordApi.approveCheckOrder({
        checkId: checkId
      }).then(resp => {
        CheckRecordApi.handleResponse(resp, me, function (data) {
          me.$dialog.info({
            text: '审批通过',
            title: '操作成功'
          })
          me.auditDialog = false
          me.btnDisabled = false
          me.getDataFromApi(me.categoryId)
        }, () => {
          me.btnDisabled = false
        })
      }).catch(error => {
        CheckRecordApi.handleNetworkError(error, me, function () {
          me.btnDisabled = false
        })
      })
    },
    // 审批驳回
    auditDismissal() {
      let checkId = this.id
      let me = this
      me.btnDisabled = true
      CheckRecordApi.dismissalCheckOrder({
        checkId: checkId
      }).then(resp => {
        CheckRecordApi.handleResponse(resp, me, function (data) {
          me.$dialog.info({
            text: '审批驳回成功',
            title: '操作成功'
          })
          me.auditDialog = false
          me.btnDisabled = false
          me.getDataFromApi(me.categoryId)
        }, () => {
          me.btnDisabled = false
        })
      }).catch(error => {
        CheckRecordApi.handleNetworkError(error, me, function () {
          me.btnDisabled = false
        })
      })
    },
    // 导出
    async clickExport() {
      let me = this;
      let checkId = this.id
      let res = await CheckRecordApi.exportDetail({
        checkId: checkId
      });
      downloadUtil.downloadByBlob({res: res.data, fileName: "检查记录详情导出数据.xlsx"});
    },
    // 点击查看图片
    viewPictures(question) {
      // 处理问题图片
      let hasImg = false
      if (question.picture) {
        hasImg = true
        this.questionImgs = question.picture.split(",")
      }
      if (question.writeOffPicture) {
        hasImg = true
        this.writeOffImgs = question.writeOffPicture.split(",")
      }
      if (!hasImg) {
        this.$dialog.error({
          title: '错误',
          text: '该问题项没有图片展示'
        })
        return
      }
      this.$previewRefresh();
      this.dialogShow = true
    },
    // 关闭查看图片
    closeImgDialog() {
      this.questionImgs = null
      this.writeOffImgs = null
      this.dialogShow = false
    },
    // 点击销项计划时间
    clickWriteOffPlanTime(question) {
      // 必须是待销项状态
      if (question.writeOffStatus != 3) {
        this.$dialog.error({
          title: '错误',
          text: '待销项状态才能修改销项时间'
        })
        return
      }
      this.questionId = question.id
      this.planTime = question.writeOffPlanTime
      this.planTimeDialogShow = true
    },
    // 修改销项时间
    sureChangePlanTime() {
      let planTime = this.planTime
      if (!planTime) {
        this.$dialog.error({
          title: '错误',
          text: '请选择计划日期'
        })
        return
      }
      let questionId = this.questionId
      let me = this
      me.btnDisabled = true
      CheckRecordApi.changeWriteOffPlanTime({
        questionId: questionId,
        planTime: planTime
      }).then(resp => {
        CheckRecordApi.handleResponse(resp, me, function (data) {
          me.$dialog.info({
            text: '修改计划日期成功',
            title: '操作成功'
          })
          me.quxiaoChangePlanTime()
          me.btnDisabled = false
          me.getDataFromApi(me.categoryId)
        }, () => {
          me.btnDisabled = false
        })
      }).catch(error => {
        CheckRecordApi.handleNetworkError(error, me, function () {
          me.btnDisabled = false
        })
      })
    },
    // 取消销项时间
    quxiaoChangePlanTime() {
      this.questionId = null
      this.planTime = null
      this.planTimeDialogShow = false
    },
    // 点击销项
    clickWrite(question) {
      if (question.writeOffStatus != 3) {
        this.$dialog.error({
          title: '错误',
          text: '待销项状态才能销项'
        })
        return
      }
      this.writeOffDialogShow = true
      this.questionId = question.id
    },
    // 关闭销项弹窗
    closeWriteOff() {
      this.writeOffDialogShow = false
      this.questionId = null
      this.writeOffExplain = ""
    },
    // 确认销项
    sureWriteOff() {
      if (!this.writeOffValid) {
        this.$dialog.error({
          title: '错误',
          text: '销项原因必填'
        })
        return
      }
      let questionId = this.questionId
      let writeOffExplain = this.writeOffExplain
      let writeOffPictures = this.$refs.specUploadPic.uploadFiles
          .map(item => item.url)
          .join(",")
      let me = this
      me.btnDisabled = true
      CheckRecordApi.writeOffAssessQuestion({
        questionId: questionId,
        writeOffExplain: writeOffExplain,
        writeOffPictures: writeOffPictures
      }).then(resp => {
        CheckRecordApi.handleResponse(resp, me, function (data) {
          me.$dialog.info({
            text: '销项成功',
            title: '操作成功'
          })
          me.closeWriteOff()
          me.btnDisabled = false
          me.getDataFromApi(me.categoryId)
        }, () => {
          me.btnDisabled = false
        })
      }).catch(error => {
        CheckRecordApi.handleNetworkError(error, me, function () {
          me.btnDisabled = false
        })
      })

    },
    _hasButtonPermission(name) {
      let buttonPriviledgeList = this.buttonPriviledgeList
      let hasButton = false
      for (let i = 0; i < buttonPriviledgeList.length; i++) {
        if (buttonPriviledgeList[i].name == name) {
          if (buttonPriviledgeList[i].hasPriviledge == 'Y') {
            return true
          } else {
            return false
          }
        }
      }
      return false
    },
    _jungleWriteOffStatus(status) {
      if (status == 1) {
        return "待填写完成"
      } else if (status == 2) {
        return "已填写完成"
      } else if (status == 3) {
        return "待销项"
      } else if (status == 4) {
        return "已销项"
      } else {
        return "无问题"
      }
    },
    _calcRow31(list) {
      let rows = 0
      for (let i = 0; i < list.length; i++) {
        for (let j = 0; j < list[i].children.length; j++) {
          rows += list[i].children[j].pointList.length
        }
      }
      return rows
    },
    _calcRow32(list) {
      let rows = 0
      for (let i = 0; i < list.length; i++) {
        rows += list[i].pointList.length
      }
      return rows
    },
    _getTodayDateStr() {
      var today = new Date();
      var month = today.getMonth() + 1;
      month = month < 10 ? '0' + month : month;
      var day = today.getDate() < 10 ? '0' + today.getDate() : today.getDate();
      return today.getFullYear() + '/' + month + '/' + day;
    }
  }
};
</script>
<style scoped>
.container {
  padding: 0;
}

.row {
  margin: 0;
}

.padding-bottom {
  padding: 0 16px;
  /**padding-bottom: 12px;**/
}

.padding-top {
  padding-top: 30px;
}

.margin-right {
  margin-right: 12px;
}

.v-application p {
  margin-bottom: 0;
}
</style>